export const messages = {
  en: {
    inspectionPlanDetail: {
      title: 'Inspection Plan Detail',
      planName: 'Plan Name',
      planRoute: 'Plan Route',
      planPeriod: 'Plan Period',
      signType: 'Sign Type',
      dateRange: 'Date Range',
      timeRange: 'Time Range',
      beforeTime: 'Before Time (min)',
      creator: 'Creator',
      createTime: 'Create Time',
      status: 'Status',
      staff: 'Staff',
      route: 'Route',
      point: 'Point',
      task: 'Task',
      detail: 'Detail',
      staffName: 'Staff Name',
      startTime: 'Start Time',
      endTime: 'End Time',
      routeList: 'Route List',
      pointId: 'Point ID',
      pointName: 'Point Name',
      pointType: 'Point Type',
      pointLocation: 'Location',
      pointTimeRange: 'Time Range',
      sortNumber: 'Sort Number',
      operation: 'Operation',
      choosePoint: 'Choose Inspection Point',
      pointNamePlaceholder: 'Enter point name',
      deletePointConfirm: 'Are you sure to delete this inspection point?',
      editPoint: 'Edit Inspection Point',
      startTimePlaceholder: 'Select start time',
      endTimePlaceholder: 'Select end time',
      sortNumberPlaceholder: 'Enter sort number',
      startTimeRequired: 'Start time is required',
      endTimeRequired: 'End time is required',
      sortNumberRequired: 'Sort number is required',
      sortNumberMustBeNumber: 'Sort number must be a number',
      choosePointWarning: 'Please select at least one inspection point',
      taskList: 'Task List',
      taskDetailId: 'Task Detail ID',
      taskStatus: 'Task Status',
      planUser: 'Plan User',
      actualUser: 'Actual User',
      signStatus: 'Sign Status',
      pointStatus: 'Point Status',
      inspectionDesc: 'Description',
      inspectionPhoto: 'Photos',
      planTimeRange: 'Plan Time',
      actualTime: 'Actual Time',
      searchPlanUser: 'Search by user',
      searchStartTime: 'Start time',
      searchEndTime: 'End time'
    }
  },
  zh: {
    inspectionPlanDetail: {
      title: '巡检计划详情',
      planName: '计划名称',
      planRoute: '计划路线',
      planPeriod: '计划周期',
      signType: '签到方式',
      dateRange: '日期范围',
      timeRange: '时间范围',
      beforeTime: '任务提前(分钟)',
      creator: '制定人',
      createTime: '制定时间',
      status: '状态',
      staff: '巡检人员',
      route: '巡检路线',
      point: '巡检点',
      task: '巡检任务',
      detail: '巡检明细',
      staffName: '巡检人员',
      startTime: '开始时间',
      endTime: '结束时间',
      routeList: '路线列表',
      pointId: '巡检点ID',
      pointName: '巡检点名称',
      pointType: '巡检点类型',
      pointLocation: '巡检位置',
      pointTimeRange: '时间范围',
      sortNumber: '排序',
      operation: '操作',
      choosePoint: '选择巡检点',
      pointNamePlaceholder: '输入巡检点名称',
      deletePointConfirm: '确定删除该巡检点吗？',
      editPoint: '修改巡检点',
      startTimePlaceholder: '请填写开始时间',
      endTimePlaceholder: '请填写结束时间',
      sortNumberPlaceholder: '请填写排序值',
      startTimeRequired: '开始时间不能为空',
      endTimeRequired: '结束时间不能为空',
      sortNumberRequired: '排序不能为空',
      sortNumberMustBeNumber: '顺序必须是数字',
      choosePointWarning: '请选择巡检点',
      taskList: '任务列表',
      taskDetailId: '任务详情ID',
      taskStatus: '任务状态',
      planUser: '计划巡检人',
      actualUser: '实际巡检人',
      signStatus: '实际签到状态',
      pointStatus: '巡检点状态',
      inspectionDesc: '巡检情况',
      inspectionPhoto: '巡检照片',
      planTimeRange: '计划时间',
      actualTime: '实际巡检时间',
      searchPlanUser: '请输入巡检人',
      searchStartTime: '实际巡检开始时间',
searchEndTime: '实际巡检结束时间'
    }
  },
  'zh-TW': {
    inspectionPlanDetail: {
      title: '巡檢計劃詳情',
      planName: '計劃名稱',
      planRoute: '計劃路線',
      planPeriod: '計劃週期',
      signType: '簽到方式',
      dateRange: '日期範圍',
      timeRange: '時間範圍',
      beforeTime: '任務提前(分鐘)',
      creator: '制定人',
      createTime: '制定時間',
      status: '狀態',
      staff: '巡檢人員',
      route: '巡檢路線',
      point: '巡檢點',
      task: '巡檢任務',
      detail: '巡檢明細',
      staffName: '巡檢人員',
      startTime: '開始時間',
      endTime: '結束時間',
      routeList: '路線列表',
      pointId: '巡檢點ID',
      pointName: '巡檢點名稱',
      pointType: '巡檢點類型',
      pointLocation: '巡檢位置',
      pointTimeRange: '時間範圍',
      sortNumber: '排序',
      operation: '操作',
      choosePoint: '選擇巡檢點',
      pointNamePlaceholder: '輸入巡檢點名稱',
      deletePointConfirm: '確定刪除該巡檢點嗎？',
      editPoint: '修改巡檢點',
      startTimePlaceholder: '請填寫開始時間',
      endTimePlaceholder: '請填寫結束時間',
      sortNumberPlaceholder: '請填寫排序值',
      startTimeRequired: '開始時間不能為空',
      endTimeRequired: '結束時間不能為空',
      sortNumberRequired: '排序不能為空',
      sortNumberMustBeNumber: '順序必須是數字',
      choosePointWarning: '請選擇巡檢點',
      taskList: '任務列表',
      taskDetailId: '任務詳情ID',
      taskStatus: '任務狀態',
      planUser: '計劃巡檢人',
      actualUser: '實際巡檢人',
      signStatus: '實際簽到狀態',
      pointStatus: '巡檢點狀態',
      inspectionDesc: '巡檢情況',
      inspectionPhoto: '巡檢照片',
      planTimeRange: '計劃時間',
      actualTime: '實際巡檢時間',
      searchPlanUser: '請輸入巡檢人',
      searchStartTime: '實際巡檢開始時間',
      searchEndTime: '實際巡檢結束時間'
    }
  }
}